import { HttpClient, HttpHeaders } from '@angular/common/http';
import { inject, Injectable, OnDestroy } from '@angular/core';
import { environment } from '../../environments/environment';
import { getUser, httpOptions, storeTokens,getFromLocalStorage,setIntoLocalStorage } from '@portal-workspace/grow-ui-library';
import { GetHeartbeatLogsFn, HeartbeatEvent, HeartbeatLog, PayloadApiResponse, RefreshTokenPayload,parseJSON ,stringifyJSON} from '@portal-workspace/grow-shared-library';
import moment from 'moment';
import { BehaviorSubject, Subject } from 'rxjs';
import _ from 'lodash';

const URL_REFRESH_TOKEN = () => `${environment.api2Host}/api2/refresh-token`;

@Injectable()
export class HeartbeatService implements OnDestroy {


    HEARTBEAT_INTERVAL = 1000 * 60 * 1; // 1 minutes
    MAX_LOGS = 10;

    httpClient = inject(HttpClient);

    ref: any;

    logs: HeartbeatLog[] = [];
    logsSubject: Subject<HeartbeatLog[]> = new BehaviorSubject<HeartbeatLog[]>(this.logs);
    subject: Subject<HeartbeatEvent> = new Subject<HeartbeatEvent>();

    init() {
        console.log('heartbeat init');
        this.ref = setInterval(() => {
            try {
                this.heartbeat();
            } catch(err) {
                console.error('heartbeat error', err);   
            }
        }, this.HEARTBEAT_INTERVAL);
    }

    ngOnDestroy(): void {
        if (this.ref) {
            clearInterval(this.ref);
        }
        console.log('heartbeat destroy');
    }


    getHeartbeatLogsFn: GetHeartbeatLogsFn = () => {
        return this.logsSubject.asObservable();
    }

    heartbeat() {
        const currentUser = getUser();
        const refreshToken = currentUser?.refreshToken;
        if (!refreshToken) {
            return;
        }
        this.httpClient.post<PayloadApiResponse<RefreshTokenPayload | undefined>>(URL_REFRESH_TOKEN(), {
            refreshToken,
            source: 'heartbeat',
        }, httpOptions()).subscribe((res) => {
            if (res.status && res.payload) {
                console.log('heartbeat success');
                const newUser = res.payload.user;
                const refreshToken = res.payload.refreshToken;
                const accessToken = res.payload.accessToken;
                const token = {
                  user: newUser,
                  refreshToken,
                  accessToken
                };
                storeTokens(token);
                this.addLog({date: moment().format('DD/MM/YYYY hh:mm:ss a'), message: `heartbeat success`});

                // fire events
                if (currentUser) {
                    if (newUser.AccessLevel && 
                        currentUser.AccessLevel && 
                        newUser.AccessLevel !== currentUser.AccessLevel) {
                        this.subject.next({
                            type: 'HeartbeatAccessLevelChangedEvent',
                            userId: currentUser.UserId,
                            oldAccessLevel: currentUser.AccessLevel,
                            newAccessLevel: newUser.AccessLevel,
                        });
                    }
                    if (!currentUser.isDisabled  && 
                        newUser.isDisabled) {
                        this.subject.next({
                            type: 'HeartbeatUserDisabledEvent',
                            userId: currentUser.UserId,
                            isDisabled: true,
                        });
                    }
                }
            } else {
                console.log('heartbeat failed');
                this.addLog({date: moment().format('DD/MM/YYYY HH:mm:ss'), message: `heartbeat failed - ${res.message}`});
            }
        });

        const growAdminRefreshToken = parseJSON(getFromLocalStorage("adminGrowRefreshToken"));
        const growAccessToken = parseJSON(getFromLocalStorage("adminGrowAccessToken"));
        const growAdminUser = parseJSON(getFromLocalStorage("adminGrowUser"));

        if(!_.isEmpty(localStorage.getItem("isImpersonate")) && growAdminUser && growAccessToken && growAdminRefreshToken){
            const headers = new HttpHeaders({
                'Authorization': `Bearer ${growAccessToken}` 
            })
            const options = { headers: headers };
            this.httpClient.post<PayloadApiResponse<RefreshTokenPayload | undefined>>(URL_REFRESH_TOKEN(), {
                refreshToken:growAdminRefreshToken,
                source: 'heartbeat',
            }, options).subscribe((res) => {
                if (res.status && res.payload) {
                    console.log('Admin heartbeat success');
                    const newAdminUser = res.payload.user;
                    const adminRefreshToken = res.payload.refreshToken;
                    const adminAccessToken = res.payload.accessToken;
                    setIntoLocalStorage("adminGrowUser", stringifyJSON(newAdminUser));
                    setIntoLocalStorage("adminGrowRefreshToken", stringifyJSON(adminRefreshToken));
                    setIntoLocalStorage("adminGrowAccessToken", stringifyJSON(adminAccessToken));

                    this.addLog({date: moment().format('DD/MM/YYYY hh:mm:ss a'), message: `Admin heartbeat success`});
                } else {
                    console.log('Admin heartbeat failed');
                    this.addLog({date: moment().format('DD/MM/YYYY HH:mm:ss'), message: `Admin heartbeat failed - ${res.message}`});
                }
          });
        }
    }

    addLog(log: HeartbeatLog) {
        this.logs.push(log);
        if (this.logs.length > this.MAX_LOGS) {
            this.logs.shift();
        }
        this.logsSubject.next(this.logs);
    }
}


